import type { CustomSpacing } from './types';

const spacing: CustomSpacing = {
  outlineSpace: 16,
};

export default spacing;
